import * as React from 'react';

import LazyLoad from 'react-lazyload';

export enum Debounce {
  Instant = 0,
  Short = 500,
  Medium = 1000,
  Long = 2000,
}

type Props = {
  children: React.ReactNode;
  debounce?: Debounce;
  height?: string | number;
  placeholder?: React.ReactNode;
};

export default React.memo(
  (props: Props): JSX.Element => {
    const {
      placeholder,
      children,
      height,
      debounce = Debounce.Instant,
    } = props;

    return (
      <LazyLoad
        debounce={debounce}
        height={height}
        placeholder={placeholder}
        once={true}
      >
        {children}
      </LazyLoad>
    );
  },
);
